import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './services/http/auth.service';
import { TwoFactorService } from './components/two-factor-popup/two-factor.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'identitiy-server-web-app';
  private idleTimer: any;
  private countdownInterval: any;
  private readonly idleTimeout = 15 * 60 * 1000; // 15 minutes
  private idleStartTime: number = 0;
  private routerSub!: Subscription;

  constructor(private router: Router, private authService: AuthService, private twoFactorService: TwoFactorService) {
  }

  ngOnInit() {
    this.resetIdleTimer();
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.resetIdleTimer());
  }

  ngOnDestroy() {
    clearTimeout(this.idleTimer);
    clearInterval(this.countdownInterval);
    this.routerSub?.unsubscribe();
  }

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  @HostListener('document:click')
  @HostListener('document:scroll')
  onUserActivity() {
    this.resetIdleTimer();
  }

  private resetIdleTimer() {
    clearTimeout(this.idleTimer);
    clearInterval(this.countdownInterval);
    const isLoggedIn = this.authService.isLoggedIn();
    if (isLoggedIn) {
      this.idleStartTime = Date.now();
      this.countdownInterval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - this.idleStartTime) / 1000);
        const remaining = Math.floor(this.idleTimeout / 1000) - elapsed;
      }, 5000);
      this.idleTimer = setTimeout(() => {
        clearInterval(this.countdownInterval);
        localStorage.removeItem('token');
        this.router.navigate(['/login']);
      }, this.idleTimeout);
    }
  }

  public urlContains(part: any) {
    return this.router.url.includes(part);
  }
}
